import {Schedule} from "@/entity/Schedule";
import style from "@/components/schedule/schedule.scss";
import {Col, Row} from "react-bootstrap";
import React from "react";
import {Date} from "@/components/atom/Date";
import globalStyle from "@/styles/Global.scss";

const ScheduleView = ({schedule = new Schedule({})}) => {
  return (<>
    <div className={style.container}>
      <Row>
        <Col className={`${style.date}`} xs={12}>
          <Date date={schedule.getDate()} holiday={schedule.holiday} />
        </Col>
      </Row>
      <Row>
        <Col className={`${style.date} ${schedule.holiday ? style.holiday : ''}`} xs={12}>
          { schedule.holiday ? '休業日' : '営業日' }
        </Col>
      </Row>
      <Row>
        <Col className={style.date} xs={12}>
          { schedule.businessHour }
        </Col>
      </Row>
      <Row>
        <Col className={style.date} xs={12}>
          <span style={{color: schedule.holiday ? 'rgb(42, 167, 56)' : 'black'}}>{ schedule.memo }</span>
        </Col>
      </Row>
      <hr className={globalStyle.separator} />
    </div>
  </>)
}

export default ScheduleView;
